<template>
  <div class="packets">
    <header-main class="anchored"></header-main>
    <nav-mobile></nav-mobile>
    <section id="packets">
      <header class="subpage">
        <h3>Pakiety</h3>
        <h4>Dopasowane do twojego biznesu</h4>
      </header>
      <div class="wrapper">
        <packets-period></packets-period>
        <div class="flex">
          <div class="column">
            <div class="packet mini">
              <div class="content">
                <div class="icon"></div>
                <h5>Pakiet Mini</h5>
                <h4>{{ prices.mini[monthActive] }} PLN</h4>
                <p>netto | m-c</p>
              </div>
            </div>
            <ul>
              <li>
                <i class="material-icons">done</i>
                <p>rejestracja firmy pod adresem:<br> ul. Świeradowska 51-57, 50-559 Wrocław</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>odbieranie korespondencji przychodzącej</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>prowadzenie elektronicznego dziennika korespondencji</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>dostęp 24/7 do dziennika korespondencji</p>
              </li>
              <li class="gray">
                <i class="material-icons">close</i>
                <p>przesyłanie i dostęp do skanów korespondencji</p>
              </li>
              <li class="gray">
                <i class="material-icons">close</i>
                <p>sala konferencyjna 2h w miesiącu</p>
              </li>
              <li class="gray">
                <i class="material-icons">close</i>
                <p>wysyłka papierowej korespondencji raz w miesiącu</p>
              </li>
            </ul>
            <router-link class="default" to="/zamowienie/krok/1" @click.native="changePacket(1)">Wybierz</router-link>
          </div>
          <div class="column">
            <div class="packet standard">
              <div class="chosen">
                <div class="triangle left"></div>
                <div class="triangle right"></div>
                <p>Najczęściej wybierany</p>
              </div>
              <div class="content">
              <div class="icon"></div>
              <h5>Pakiet Standard</h5>
              <h4>{{ prices.standard[monthActive] }} PLN</h4>
              <p>netto | m-c</p>
            </div>
            </div>
            <ul>
              <li>
                <i class="material-icons">done</i>
                <p>rejestracja firmy pod adresem:<br> ul. Świeradowska 51-57, 50-559 Wrocław</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>odbieranie korespondencji przychodzącej</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>prowadzenie elektronicznego dziennika korespondencji</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>dostęp 24/7 do dziennika korespondencji</p>
              </li>
              <li class="blue">
                <i class="material-icons">done</i>
                <p>przesyłanie i dostęp do skanów korespondencji</p>
              </li>
              <li class="gray">
                <i class="material-icons">close</i>
                <p>sala konferencyjna 2h w miesiącu</p>
              </li>
              <li class="gray">
                <i class="material-icons">close</i>
                <p>wysyłka papierowej korespondencji raz w miesiącu</p>
              </li>
            </ul>
            <router-link class="default" to="/zamowienie/krok/1" @click.native="changePacket(2)">Wybierz</router-link>
          </div>
          <div class="column">
            <div class="packet comfort">
              <div class="content">
                <div class="icon"></div>
                <h5>Pakiet Komfort</h5>
                <h4>{{ prices.komfort[monthActive] }} PLN</h4>
                <p>netto | m-c</p>
              </div>
            </div>
             <ul>
               <li>
                <i class="material-icons">done</i>
                <p>rejestracja firmy pod adresem:<br> ul. Świeradowska 51-57, 50-559 Wrocław</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>odbieranie korespondencji przychodzącej</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>prowadzenie elektronicznego dziennika korespondencji</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
              </li>
              <li>
                <i class="material-icons">done</i>
                <p>dostęp 24/7 do dziennika korespondencji</p>
              </li>
              <li class="blue">
                <i class="material-icons">done</i>
                <p>przesyłanie i dostęp do skanów korespondencji</p>
              </li>
              <li class="blue">
                <i class="material-icons">done</i>
                <p>sala konferencyjna 2h w miesiącu</p>
              </li>
              <li class="blue">
                <i class="material-icons">done</i>
                <p>wysyłka papierowej korespondencji raz w miesiącu</p>
              </li>
            </ul>
            <router-link class="default" to="/zamowienie/krok/1" @click.native="changePacket(3)">Wybierz</router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="last">
      <div class="flex">
        <h5>Skontaktuj się nami już dzisiaj!</h5>
        <router-link to="/kontakt" class="default">Napisz lub zadzwoń</router-link>
      </div>
      <div class="img"></div>
    </section>
    <footer-main></footer-main>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'
import PacketsPeriod from '@/components/PacketsPeriod.vue'

export default {
  name: 'Contact',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
    PacketsPeriod
  },
  computed:{
    monthActive(){
      return this.$store.state.monthActive;
    },
    prices(){
      return this.$store.state.prices;
    }
  },
  methods: {
    changePacket(id){
      this.$store.commit('changePacket', id);
      if(typeof localStorage.packet == 'undefined'){
        localStorage.setItem('packet', id);
      }else{
        localStorage.packet = id;
      }
    },
  }
}
</script>
<style scoped lang="scss">
  div.packets-period { margin: 60px auto; }
  div.flex { display: flex; flex-wrap: wrap; justify-content: center; margin: 60px 0 80px 0; }
  div.column div.packet { margin: 50px 50px 0 50px; }
  div.column ul { width: 300px; margin: 0 auto; padding: 0; list-style: none; }
  div.column ul li { display: flex; margin: 5px 0; padding: 7px; background: rgba(228, 228, 230, 1); color: $fontBlack; border-radius: 3px; }
  div.column ul li i.material-icons { display: block; width: 24px; height: 24px; line-height: 20px; font-size: 24px; text-align: center; color: $orangeDark; }
  div.column ul li.blue i.material-icons { color: $blueDark; }
  div.column ul li.gray { opacity: 0.4; }
  div.column ul li.gray i.material-icons { color: $grayLight; }
  div.column ul li p { margin: 0 0 0 10px; padding: 0; font-size: 13px; line-height: 24px; }
  div.column a.default { display: block; width: 300px; margin: 5px auto; padding: 0; height: 40px; text-align: center; line-height: 38px; font-size: 16px; border: 2px solid $orangeDark; }
  div.column a.default:hover { height: 40px; padding: 0; }
  div.chosen { width: 300px; position: absolute; top: -30px; background: $blueLighter; }
  div.chosen p { margin: 0; padding: 0; height: 30px; line-height: 31px; text-align: center; font-size: 14px; color: #fff; }
  div.chosen div.triangle.left { position: absolute; width: 0; height: 0; border-top: 30px solid transparent; border-bottom: 30px solid transparent; 
    border-left: 30px solid $blueLighter; z-index: 2; }
  div.chosen div.triangle.right { position: absolute; right: 0; width: 0; height: 0; border-top: 30px solid transparent; border-bottom: 30px solid transparent; 
    border-right: 30px solid $blueLighter; z-index: 2; }
  section.last { height: 371px; position: relative; }
  section.last div.flex { display: flex; flex-direction: column; justify-content: center; align-items: center; margin: 0; position: absolute; left: 50%; z-index: 2; }
  section.last h5 { margin: 0 0 30px 0; padding: 20px 50px; background: $grayLight; color: #fff; font-size: 24px; font-weight: 500; }
  section.last div.img { width: 100%; height: 350px; position: absolute; bottom: 0; z-index: 1; background: url('../assets/banner_bottom.webp') no-repeat 50% 50%; }

  div.packet { width: 300px; height: 266px; }
  div.packet.mini { background: url('../assets/packet_mini_smaller2.webp') no-repeat 50% 50%; }
  div.packet.standard { background: url('../assets/packet_standard_smaller2.webp') no-repeat 50% 50%; }
  div.packet.comfort { background: url('../assets/packet_comfort_smaller2.webp') no-repeat 50% 50%; }
  div.packet div.content { height: 166px; }
  div.packet div.content h5 { font-size: 16px; }
  div.packet div.content h4 { font-size: 30px; }
  div.packet div.content p { font-size: 13px; }

  @media (max-width: 1100px) {
    section.last div.flex { width: 100vw; left: 0; }
    section.last h5 { margin: 0 auto 30px auto; }
  }

  @media (max-width: 700px) {
    section.last h5 { padding: 10px 30px; font-size: 18px; text-align: center; }
    section.last { height: 175px; }
    section.last div.img { display: none; }
  }

  @media (max-width: 300px) {
    div.column ul { width: calc(100vw - 40px); }
    div.chosen { width: calc(100vw - 40px); }
    div.packet { width: calc(100vw - 40px); }
    div.column a.default { width: calc(100vw - 40px); }
  }

  @media (max-width: 400px) {
    section.last h5 { width: calc(100vw - 40px); }
  }
</style>
